// Axis store
// --------------------------------------------------------
import api from '@/lib/api'
import utils from '@/store/modules/landscape/utils'

const state = {
  axes: null,
  axesDic: {},
  axesParsed: false
}

const getters = {
  axes: state => state.axes,
  axesDic: state => state.axesDic,
  axesParsed: state => state.axesParsed,
  getAxisByID: state => axisId => state.axesDic[axisId],
  totalAxes: state => Object.keys(state.axesDic).length
}

const mutations = {
  parseInsightAxes(state, insights) {
    utils.parseAxes(state.axes.children, insights || [])
  },
  setAxes(state, {axes, insights}) {
    if (Array.isArray(insights)) state.axesParsed = true
    // do not swap order!
    state.axesDic = utils.parseAxes(axes, insights || [])
    state.axes = {children: axes}
  },
  updateName(state, editedAxis) {
    const axis = state.axesDic[editedAxis.axisId]
    if (!axis) return
    axis.name = editedAxis.name
  }
}

const actions = {
  loadAxes({getters, commit}) {
    const landscapeId = getters.currentLandscapeId
    const path = `landscapes/${landscapeId}/axes`
    return api.call('get', path).then(axes =>
      commit('setAxes', {
        axes,
        insights: getters['insights/filters/insightsAxes']
      })
    )
  },
  createAxis: ({getters, commit}, payload) => {
    const landscapeId = getters.currentLandscape._id
    const axisId = payload.axisId ? payload.axisId : ''
    const name = {name: payload.name}
    return api
      .call('post', `landscapes/${landscapeId}/axes/${axisId}`, name)
      .then(response =>
        commit('setAxes', {
          axes: response.axes,
          insights: getters['insights/filters/insightsAxes']
        })
      )
  },
  editAxis: ({getters, commit}, payload) => {
    commit('updateName', payload)
    const landscapeId = getters.currentLandscape._id
    const name = {name: payload.name}
    return api.call(
      'put',
      `landscapes/${landscapeId}/axes/${payload.axisId}`,
      name
    )
  },
  deleteAxis: ({getters, commit}, payload) => {
    const landscapeId = getters.currentLandscape._id
    return api
      .call('delete', `landscapes/${landscapeId}/axes/${payload.axisId}`)
      .then(response =>
        commit('setAxes', {
          axes: response.axes,
          insights: getters['insights/filters/insightsAxes']
        })
      )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
